import { Navigate, Route, Routes } from 'react-router-dom'

import { Layout } from './components/Layout'
import { useAuth } from './lib/auth'
import { Authorize } from './routes/Authorize'
import { Dashboard } from './routes/Dashboard'
import { ItemEdit } from './routes/ItemEdit'
import { ItemNew } from './routes/ItemNew'
import { Items } from './routes/Items'
import { Login } from './routes/Login'
import { Privacy } from './routes/Privacy'
import { Register } from './routes/Register'
import { ResetPassword } from './routes/ResetPassword'
import { Settings } from './routes/Settings'
import { Verify } from './routes/Verify'

export default function App() {
  const { isLoggedIn } = useAuth()

  if (!isLoggedIn) {
    return (
      <Routes>
        <Route path="/login" element={<Login />} />
        <Route path="/register" element={<Register />} />
        <Route path="/reset-password" element={<ResetPassword />} />
        {/* Reachable while signed out: the link comes from an email. */}
        <Route path="/verify" element={<Verify />} />
        <Route path="/privacy" element={<Privacy />} />
        {/* An MCP client opens this in a browser that may not be signed in. It
            renders a sign-in prompt rather than redirecting, so the request's
            parameters survive. */}
        <Route path="/authorize" element={<Authorize />} />
        <Route path="*" element={<Navigate to="/login" replace />} />
      </Routes>
    )
  }

  return (
    <Routes>
      {/* Outside Layout on purpose: a consent screen with the app's nav in it
          invites wandering off halfway through, leaving the client waiting. */}
      <Route path="/authorize" element={<Authorize />} />
      <Route
        path="*"
        element={
          <Layout>
            <Routes>
              <Route path="/" element={<Dashboard />} />
              <Route path="/items" element={<Items />} />
              <Route path="/items/new" element={<ItemNew />} />
              <Route path="/items/:id" element={<ItemEdit />} />
              <Route path="/settings" element={<Settings />} />
              <Route path="/privacy" element={<Privacy />} />
              <Route path="/verify" element={<Verify />} />
              <Route path="*" element={<Navigate to="/" replace />} />
            </Routes>
          </Layout>
        }
      />
    </Routes>
  )
}
